module.exports = __webpack_public_path__ + "img/upload-icon-grey.1dea04a2.svg";